/* zv-entry-gate: loader only on first entry to the site */
  (function(){var ret=false;
  try{var s=window.sessionStorage;if(s.getItem('zvSeen'))ret=true;s.setItem('zvSeen','1');}catch(e){ret=true}
  if(!ret){try{if(document.referrer){var a=document.createElement('a');a.href=document.referrer;if(a.host===location.host)ret=true}}catch(e){}}
  if(ret)document.documentElement.classList.add('zv-return')})()